/// <reference path="../../common/helpers/dialogutils.ts" />
/// <reference path="../../_ext/Editors/ItemEditorDialog.ts" />
namespace TabAurous.Purchase {

    @Serenity.Decorators.registerClass()
    export class PurchaseItemsDialog extends _Ext.ItemEditorDialog<PurchaseItemsRow> {
        protected getFormKey() { return PurchaseItemsForm.formKey; }
        protected getLocalTextPrefix() { return PurchaseItemsRow.localTextPrefix; }
        protected getDeletePermission() { return PurchaseItemsRow.deletePermission; }
        protected getInsertPermission() { return PurchaseItemsRow.insertPermission; }
        protected getUpdatePermission() { return PurchaseItemsRow.updatePermission; }

        public form = new PurchaseItemsForm(this.idPrefix);
        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;
        }

        // #region Public Variables
        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public StoneDiscount: number;
        public LaborMarkup: number;
        public LaborDiscount: number;
        public ExchangeRate: number;
        public TransDate: Date;
        public newLineNo: number;
        public Totals: number;
        public HasBom: boolean = true;
        public ItemMaster: any;
        public LotNo: any;

        // #endregion 

        // #region Constructor
        constructor() {
            super();
            $('s-Purchase-PurchaseItemsDialog').attr('autocomplete', 'off');
            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 250;
            q.initBOMEditor(this, this.form.BOMDetails, Config);
            q.initLaborEditor(this, this.form.LaborDetails, Config);

            // #region UI
            //Make grid full width
            q.hideEditorLabel(this.form.BOMDetails);
            q.hideEditorLabel(this.form.ImageName);
            q.hideEditorLabel(this.form.LaborDetails);
            // **** Assign Values to BOM and Labor Editor ****
            //Set Numeric Fields as Right Align
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.NetAmount);
            q.setTextRightAlign(this.form.NetWeight);
            q.setTextRightAlign(this.form.DiamondAmount);
            q.setTextRightAlign(this.form.DiamondPieces);
            q.setTextRightAlign(this.form.DiamondWeight);
            q.setTextRightAlign(this.form.GrossAmount);
            q.setTextRightAlign(this.form.Discount);
            q.setTextRightAlign(this.form.OtherAmount);
            q.setTextRightAlign(this.form.OtherWeight);
            q.setTextRightAlign(this.form.OtherPieces);
            q.setTextRightAlign(this.form.UnitRate);
            q.setTextRightAlign(this.form.Purity);
            q.setTextRightAlign(this.form.StonePieces);
            q.setTextRightAlign(this.form.StoneWeight);
            q.setTextRightAlign(this.form.WstPer);
            q.setTextRightAlign(this.form.WstWt);
            q.setTextRightAlign(this.form.UnitLabour);
            q.setTextRightAlign(this.form.MF);
            q.setTextRightAlign(this.form.MFAmount);


            // #endregion

            // #region Field Change Events

            this.form.Pieces.changeSelect2(e => {
                this.UpdateLabor();
                if (this.form.HasBom.value)
                    this.CalculateTotals();
                else
                    this.CalculateRate();
            });

            this.form.CategoryId.changeSelect2(e => {
                this.form.SubCategoryId.CategoryId = parseInt(this.form.CategoryId.value);
                this.form.SubCategoryId.updateItems();
                this.form.ProductSizeId.CategoryId = parseInt(this.form.CategoryId.value);
                this.form.ProductSizeId.updateItems();
                ItemFieldHelper.PurchaseItemFields(this, this.ItemMaster.form.VoucherTypeId.value);

                //this.Setfields();
            })

            this.form.Weight.changeSelect2(e => {
                if (!isNaN(this.form.Weight.value)) {
                    this.UpdateLabor();
                    this.CalculateRate();
                }

            });

            this.form.UnitRate.changeSelect2(e => {
                if (this.form.UnitRate.value != null)
                    this.CalculateRate();
            });

            this.form.CalcOnId.changeSelect2(e => {
                if (this.form.CalcOnId.value != "")
                    this.CalculateRate();
            });

            this.form.NetAmount.changeSelect2(e => {
                if (this.form.NetAmount.value != null)
                    this.form.GrossAmount.value = this.form.Pieces.value * this.form.NetAmount.value;
            });

            this.form.WstPer.changeSelect2(e => {
                this.form.WstWt.value = this.form.NetWeight.value * ((this.form.WstPer.value) / 100);

            });

            this.form.ProductTypeId.changeSelect2(e => {
                if (this.form.ProductTypeId.value != "") {
                    this.form.ItemTypeId.value = OMS.ProductTypeRow.getLookup().itemById[parseInt(this.form.ProductTypeId.value)].ItemTypeId;
                    this.entity.ItemTypeId = this.form.ItemTypeId.value;
                    this.form.CategoryId.ItemTypeId = this.form.ItemTypeId.value;
                    this.form.CategoryId.updateItems();
                    this.form.SubCategoryId.value = "";
                    ItemFieldHelper.PurchaseItemFields(this, this.ItemMaster.form.VoucherTypeId.value);
                    //this.Setfields();
                }
            });

            this.form.UnitLabour.changeSelect2(e => {
                if (this.form.UnitLabour.value != null) {
                    this.form.NetAmount.value = this.form.UnitRate.value + this.form.UnitLabour.value;
                    if (this.form.Pieces.value != null) {
                        this.form.GrossAmount.value = this.form.Pieces.value * this.form.NetAmount.value;
                    }
                }
            });

            this.form.ProductCode.changeSelect2(e => {
                if (this.form.ProductCode.value != null) {
                    try {

                        let PrdId = 0;
                        var equalFilter = { "ProductCode": this.form.ProductCode.value.toUpperCase() };

                        OMS.ProductMasterService.List({ EqualityFilter: equalFilter, Take: 1 },
                            response => {
                                if (response.Entities.length > 0)
                                    PrdId = response.Entities[0].ProductId;
                            }, {
                            async: false
                        }
                        );

                        if (PrdId > 0) {
                            Q.notifyError("Duplicate Product Code " + this.form.ProductCode.value);
                            this.form.ProductCode.value = "";
                            this.form.ProductCode.element.focus();
                            return;
                        }
                        else {
                            this.form.ProductCode.value = this.form.ProductCode.value.toUpperCase();
                        }

                    }
                    catch (undefined) {

                    }
                }
            });

            this.form.SubCategoryId.changeSelect2(e => {
                if (!Q.isEmptyOrNull(this.form.SubCategoryId.value))
                    ItemFieldHelper.PurchaseItemFields(this, this.ItemMaster.form.VoucherTypeId.value);

                //this.Setfields();
            });

            this.form.HasBom.changeSelect2(e => {
                var self = this;
                if (this.form.BOMDetails.getItems().length > 0) {
                    q.information(q.text("Message.Voucher.ReadOnly", "Are you sure?"), q.text("Message.Voucher.ReadOnlyInfo", "This will remove all components"), true, function () {
                        self.removeBOM();
                        ItemFieldHelper.PurchaseItemFields(self, self.ItemMaster.form.VoucherTypeId.value);
                    }, function () {
                        self.form.HasBom.value = true;
                    });
                } else
                    ItemFieldHelper.PurchaseItemFields(this, this.ItemMaster.form.VoucherTypeId.value);
            });

            var min = 0, max = 0, std = 0;
            this.form.KaratId.changeSelect2(e => {
                if (!Q.isEmptyOrNull(this.form.KaratId.value)) {

                    var KaratId = Q.toId(this.form.KaratId.value);
                    var purity: OMS.AttributeMasterRow;
                    OMS.AttributeMasterService.Retrieve({ EntityId: parseInt(KaratId) }, response => {
                        purity = response.Entity
                    }, { async: false });
                    var min = purity.MinPurity;
                    var max = purity.MaxPurity;
                    var std = purity.StdPurity;
                    q.showAndSetRequiredField(this.form.Purity);
                    this.form.Purity.value = std;
                    this.form.Purity.value = std;
                    var date = new Date((this.parentEditor.parentDialog as PurchaseMasterDialog).form.TransDate.value);
                    this.form.UnitRate.value = RateHelper.GetMetalRate(parseInt(this.form.MetalId.value), parseInt(this.form.KaratId.value), false, date) / this.ExchangeRate;
                }

            });

            this.form.MetalId.changeSelect2(e => {
                if (!Q.isEmptyOrNull(this.form.MetalId.value)) {
                    q.showAndSetRequiredField(this.form.KaratId);
                    this.form.KaratId.cascadeField = "Num1";
                    this.form.KaratId.cascadeValue = this.form.MetalId.value;
                }
            })

            this.form.Purity.change(e => {
                var KaratId = Q.toId(this.form.KaratId.value);
                var purity: OMS.AttributeMasterRow;
                OMS.AttributeMasterService.Retrieve({ EntityId: parseInt(KaratId) }, response => {
                    purity = response.Entity
                }, { async: false });
                var min = purity.MinPurity;
                var max = purity.MaxPurity;
                var std = purity.StdPurity;
                if (this.form.Purity.value != null) {
                    var current = this.form.Purity.value;
                    if (current < min || current > max) {
                        Q.alert("Enter Purity between  " + min + "  to  " + max);
                        this.form.Purity.value = this.form.Purity.value;
                    }
                    this.CalculateRate();
                }
            });

            this.form.StoneSizeId.changeSelect2(e => {
                this.GetRate();
            });

            this.form.ShapeId.changeSelect2(e => {
                this.GetRate();
            });

            this.form.SieveId.changeSelect2(e => {
                var SieveId = Q.toId(this.form.SieveId.value);
                var sievegroupid = OMS.AttributeMasterRow.getLookup().itemById[SieveId].GroupSieveId;
                this.form.GroupSieveId.value = sievegroupid.toString();
                this.GetRate();
            });

            this.form.QualityId.changeSelect2(e => {
                this.GetRate();
            });

            this.form.StoneColorId.changeSelect2(e => {
                this.GetRate();
            });

            this.form.MF.changeSelect2(e => {
                this.form.MFAmount.value = this.form.GrossAmount.value / this.form.MF.value;
            });

            this.form.StoneRate.changeSelect2(e => {
                this.form.StoneAmount.value = this.form.StoneWeight.value * this.form.StoneRate.value;
                this.CalculateRate();
            });

            this.form.StoneWeight.changeSelect2(e => {
                this.form.StoneAmount.value = this.form.StoneWeight.value * this.form.StoneRate.value;
                this.CalculateRate();
            });

            // #endregion

            //*** BOM row add Edit Delete Event ****

            (this.form.BOMDetails.view as any).onRowCountChanged.subscribe(() => {
                this.CalculateTotals();
            });

            (this.form.LaborDetails.view as any).onRowCountChanged.subscribe(() => {
                this.CalculateTotals();

            });
        }

        removeBOM() {
            var item = [];
            this.form.BOMDetails.view.setItems(item, true);
        }
        // #endregion

        // #region Open Dialog, Close Dialog etc

        // **** Load Entity event to set fields values ****
        protected afterLoadEntity() {
            super.afterLoadEntity();

            this.ItemMaster = (this.parentEditor.parentDialog as PurchaseMasterDialog);
            this.RateListId = this.ItemMaster.RateListId;
            this.LaborListId = this.ItemMaster.LaborListId;
            this.StoneMarkup = this.ItemMaster.StoneMarkup;
            this.StoneDiscount = this.ItemMaster.StoneDiscount;
            this.ExchangeRate = this.ItemMaster.ExchangeRate;
            this.TransDate = this.ItemMaster.form.TransDate.valueAsDate
            //this.Setfields();
            if (this.isEditMode) {
                this.form.ProductSizeId.cascadeField = "CategoryId";
                this.form.ProductSizeId.cascadeValue = this.form.CategoryId.value;
            }
            if (this.form.ProductTypeId.value == "") {
                this.form.ProductTypeId.items = this.form.ProductTypeId.items.filter(x => x.id != "5" && x.id != "6" && x.id != "7");
            }

            ItemFieldHelper.PurchaseItemFields(this, this.ItemMaster.form.VoucherTypeId.value);

            if (this.form.ProductId.value != "")
                q.showAndDisableField(this.form.HasBom);
            //q.showAndSetRequiredField(this.form.SuperTypeId);
            //this.Setfields();

            let StockTrans;

            if (this.form.VoucherTypeId.value != null) {
                Stock.StockItemService.GetStockTransactions({
                    RefTransId: Q.parseInteger(this.form.TransId.value),
                    RefVoucherId: this.form.VoucherTypeId.value,
                    RefTransItemId: Q.parseInteger(this.form.TransItemId.value)
                },
                    response => StockTrans = response.Entities,
                    {
                        async: false
                    }
                );


                if (StockTrans.length > 0) {
                    this.setReadOnly(true);
                    this.dialogTitle = this.dialogTitle + ' : View Mode'
                    this.updateInterface();

                }
            }

        }

        getItem() {
            return this.getSaveEntity();
        }


        getPropertyItems() {
            var PropertyItems = super.getPropertyItems();
            var Setting = this.getPersistedDialogSettings();
            if (Setting != null)
                Setting.Fields.forEach(function (field) {
                    var editor = PropertyItems.filter(x => x.name == field.id)[0];
                    if (field.value != null)
                        editor.defaultValue = field.value;
                    editor.visible = field.visible;
                    editor.readOnly = field.readonly;
                    editor.required = field.required;
                });
            return PropertyItems;
        }


        getPersistedDialogSettings(): Serenity.PersistedDialogSettings {
            var storage = new TabAurous.Common.UserPreferenceStorage();
            if (storage == null)
                return null;

            var json = Q.trimToNull(storage.getItem('Item'));
            if (json != null && Q.startsWith(json, '{') && Q.endsWith(json, '}'))
                return JSON.parse(json);

            return null;
        }


        // #endregion

        protected validateBeforeSave() {
            var IsValid = true;
            this.form.AttributeId.value = "0";
            var t = this.RateListId;
            this.entity.RefTransId == null ? this.entity.RefTransId = 0 : this.entity.RefTransId = this.entity.RefTransId
            this.entity.RefTransItemId == null ? this.entity.RefTransItemId = 0 : this.entity.RefTransItemId = this.entity.RefTransItemId
            this.entity.RefVoucherId == null ? this.entity.RefVoucherId = 0 : this.entity.RefVoucherId = this.entity.RefVoucherId
            this.entity.Studded == null ? this.entity.Studded = 0 : this.entity.Studded = this.entity.Studded
            this.entity.MetalAmount == null ? this.entity.MetalAmount = 0 : this.entity.MetalAmount = this.entity.MetalAmount
            this.entity.DiamondAmount == null ? this.entity.DiamondAmount = 0 : this.entity.DiamondAmount = this.entity.DiamondAmount
            this.entity.StoneAmount == null ? this.entity.StoneAmount = 0 : this.entity.StoneAmount = this.entity.StoneAmount

            if (this.form.ItemTypeId.value == 101) {
                OMS.CommonAttributesService.GetProductATB({
                    ProductTypeId: Q.parseInteger(this.form.ProductTypeId.value),
                    ItemTypeId: this.form.ItemTypeId.value,
                    CategoryId: Q.parseInteger(this.form.CategoryId.value),
                    SubCategoryId: Q.parseInteger(this.form.SubCategoryId.value),
                    BrandId: Q.parseInteger(this.form.BrandId.value),
                    CollectionId: Q.parseInteger(this.form.CollectionId.value),
                    SuperTypeId: Q.parseInteger(this.form.SuperTypeId.value),
                    ProductSizeId: Q.parseInteger(this.form.ProductSizeId.value),
                    KaratId: Q.parseInteger(this.form.KaratId.value),
                    MetalId: Q.parseInteger(this.form.MetalId.value),
                    StampId: Q.parseInteger(this.form.StampId.value)
                },
                    response => {
                        this.form.AttributeId.value = response.AttributeId.toString(),
                            this.form.Attribute.value = response.AttributeCode
                    },
                    { async: false }
                );
            }

            if (this.form.ItemTypeId.value == 104) {
                OMS.CommonAttributesService.GetProductATB({
                    ProductTypeId: Q.parseInteger(this.form.ProductTypeId.value),
                    ItemTypeId: this.form.ItemTypeId.value,
                    CategoryId: Q.parseInteger(this.form.CategoryId.value),
                    SubCategoryId: Q.parseInteger(this.form.SubCategoryId.value),
                    MetalColorId: Q.parseInteger(this.form.MetalColorId.value),
                    KaratId: Q.parseInteger(this.form.KaratId.value)
                },
                    response => {
                        this.form.AttributeId.value = response.AttributeId.toString(),
                            this.form.Attribute.value = response.AttributeCode
                    },
                    { async: false }
                );
            }

            if (this.form.ItemTypeId.value == 105) {
                OMS.CommonAttributesService.GetProductATB({
                    ProductTypeId: Q.parseInteger(this.form.ProductTypeId.value),
                    ItemTypeId: this.form.ItemTypeId.value,
                    CategoryId: Q.parseInteger(this.form.CategoryId.value),
                    SubCategoryId: Q.parseInteger(this.form.SubCategoryId.value),
                    ShapeId: Q.parseInteger(this.form.ShapeId.value),
                    QualityId: Q.parseInteger(this.form.QualityId.value),
                    StoneSizeId: Q.parseInteger(this.form.StoneSizeId.value),
                    SieveId: Q.parseInteger(this.form.SieveId.value),
                    GroupSieveId: Q.parseInteger(this.form.GroupSieveId.value),
                    StoneColorId: Q.parseInteger(this.form.StoneColorId.value),
                    StoneCutId: Q.parseInteger(this.form.StoneCutId.value),
                    StonePolishId: Q.parseInteger(this.form.StonePolishId.value),
                    StoneSymmetryId: Q.parseInteger(this.form.StoneSymmetryId.value),
                    StoneFluorescenceId: Q.parseInteger(this.form.StoneFluorescenceId.value),
                    StoneCuletId: Q.parseInteger(this.form.StoneCuletId.value),
                    StoneGirdleId: Q.parseInteger(this.form.StoneGirdleId.value),
                    StoneTable: this.form.StoneTable.value,
                    StoneDepth: this.form.StoneDepth.value
                },
                    response => {
                        this.form.AttributeId.value = response.AttributeId.toString(),
                            this.form.Attribute.value = response.AttributeCode
                    },
                    { async: false }
                );
            }

            if (this.form.ItemTypeId.value == 101) {

                if (this.form.HasBom.value) {
                    let items = this.form.BOMDetails.getItems();
                    let count = 0;
                    if (items.length == 0) {
                        q.Alert("Can not Save!", "Components/BOM not defined", 2999, false);
                        IsValid = false;
                        return;
                    }
                    if (items.length > 0) {

                        items.forEach(function (x) {
                            if (x.ItemTypeId == 104)
                                count++
                        });

                        if (count == 0) {
                            q.Alert("Can not Save!", "Metal details not defined", 2999, false);
                            IsValid = false;
                        }
                        else
                            IsValid = true;
                    }
                    else {
                        q.Alert("Can not Save!", "Components or BOM is not defined", 2999, false);
                        IsValid = false;

                    }
                }

                var LaborDetails = this.form.LaborDetails.getItems();
                if (LaborDetails.length > 0) {
                    for (var labor of LaborDetails) {
                        if (labor.ProcessName.toUpperCase() != "WASTAGE")
                            if (labor.LabourRate == null || labor.LabourRate == 0) {
                                q.Alert("Can not Save!", "Labor Rate not defined", 2999, false);
                                IsValid = false;
                            }
                    }
                }
                 
                var value = q.ToBool(GetConfigValue(1004)); 
                if (value == true && Q.isEmptyOrNull(this.form.SKU.value)) {
                    var SKU = FormatHelper.GetFormats("SKU");
                    this.form.SKU.value = SKU;
                    this.entity.Studded = 1;
                }
                if (Q.isEmptyOrNull(this.form.Line_No.value)) {
                    Purchase.PurchaseMasterService.GetLineNo({}, response => this.form.Line_No.value = response.Line_No.toString(), {
                        async: false
                    });
                }


            }
            else {
                this.entity.Studded = 1;
            }
            if (this.form.ItemTypeId.value == 105) {
                if (Q.isEmptyOrNull(this.form.LotNo.value))
                    this.form.LotNo.value = FormatHelper.GetFormats("Lot");
            }

            if (this.form.Weight.value == 0) {
                q.Alert("Can not Save!", "Weight is undefined or 0", 2999, false);
                IsValid = false;
            }
            else {
                IsValid = true;
            }

            return IsValid;

        }
        // #endregion

    }
}